import type { DividerProps } from "@ui/components/data-display/divider/Divider";
import type { BoxProps } from "@ui/components/layout/box/Box";
import type { FlexProps } from "@ui/components/layout/flex/Flex";
import type { GridProps } from "@ui/components/layout/grid/Grid";
import type { MotionStyle } from "framer-motion";
import { space } from "ui/src/design-tokens";

export const wrapperStyles: FlexProps["sx"] = {
    flexDirection: "column",
    position: "sticky",
    fontSize: "desktopBodyTextSmall",
    top: 100,
    left: 0,
    zIndex: 2,
    pt: 2,
    pb: [6, 6, 0],
};

export const filtersContainerStyles: GridProps["sx"] = {
    display: "flex",
    alignItems: "center",
    justifyContent: ["flex-start"],
    flexWrap: "wrap",
    gap: 0.2,
};

export const filtersSummaryStyles: BoxProps["sx"] = {
    width: ["1000%", "100%", "100%", "auto"],
    fontWeight: "bold",
    whiteSpace: "nowrap",
    paddingY: 3,
    paddingX: 4,
    height: [10],
    bgColor: "white",
    shadow: "base",
    zIndex: 10,
};

export const filterButtonStyles: FlexProps["sx"] = {
    display: ["none", "none", "none", "flex"],
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    border: "white",
    gap: space["0.2"],
};

export const resultsStyles: FlexProps["sx"] = {
    alignItems: "center",
    flex: 1,
    justifyContent: ["space-between"],
    gap: space["0.2"],
    w: ["full", "full", "full", "unset"],
    button: {
        minW: [0],
        w: ["50%", "50%", "50%", "auto"],
        gap: 3,
    },
    "> div": {
        w: ["50%", "50%", "50%", "fit-content"],
        minW: 0,
        button: {
            w: "full",
            "+ div": {
                w: ["full", "full", "full", "unset"],
            },
        },
    },
};

export const dividerStyles: DividerProps["sx"] = {
    width: "100vw",
    position: "absolute",
    /* We need this static and specific value to extend the separator as full width, otherwise will create an horizontally overflow */
    left: "calc(-50vw + 49.45%)",
    bottom: 0,
};

export const filtersDialogCollapse: MotionStyle = {
    position: "absolute",
    top: 61,
    left: 0,
    zIndex: 9,
    outline: "none",
};

export const overlayStyle: FlexProps["sx"] = {
    position: "fixed",
    h: "100vh",
    w: "full",
    top: 0,
    bg: "black",
    opacity: 0.3,
    left: 0,
};
